<template>
    <a-modal
            title="配置监测项目任务"
            :okText="step===3?'关闭':'下一步'"
            cancelText="取消"
            width="1000px"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
    >
        <a-spin :spinning="spinning">
            <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}"
                          :wrapper-col="{span:16}">
                <a-row v-if="step===0||step===3">
                    <a-col span="12">
                        <a-form-model-item label="项目名称" prop="name">
                            <a-input :disabled="true" v-model="formState.name"></a-input>
                        </a-form-model-item>
                    </a-col>

                    <a-col span="12">
                        <a-form-model-item label="监测品类" prop="hangye">
                            <a-input :disabled="true"  v-model="formState.hangye"></a-input>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row v-if="step===0||step===3">
                    <a-col span="12">
                        <a-form-model-item label="所属方案" prop="plan.name">
                            <a-input :disabled="true"  v-model="formState.plan.name"></a-input>
                        </a-form-model-item>
                    </a-col>

                    <a-col span="12">
                        <a-form-model-item label="抽检任务类型" prop="taskType">
                            <a-ext-local-dic-select :disabled="disabledFB"  dic-key="MonitProjectType"
                                                    v-model="formState.taskType"></a-ext-local-dic-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row v-if="step===0||step===3">
                    <a-col span="12">
                        <a-form-model-item label="监测项目实施时间" prop="startDate">
                            <a-ext-data-picker :disabled="disabledFB" v-model="formState.startDate"></a-ext-data-picker>
                        </a-form-model-item>
                    </a-col>

                    <a-col span="12">

                        <a-form-model-item :label-col="{span:0}" :wrapper-col="{span:20}" prop="endDate">
                            <span style="display:inline-block;width: 100px">至</span>
                            <a-ext-data-picker :disabled="disabledFB" v-model="formState.endDate"></a-ext-data-picker>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row v-if="step===0||step===3">
                    <a-col span="24">
                        <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="监测环节" prop="monitLink">
                            <a-ext-monit-link-check-box :disabled="disabledFB" v-model="formState.monitLink"></a-ext-monit-link-check-box>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row v-if="step===0||step===3">
                    <a-col span="12">
                        <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="抽样单模板选择"
                                           prop="pickFormId">
                            <a-ext-pick-sheet-select :disabled="disabledFB" v-model="formState.pickFormId"></a-ext-pick-sheet-select>
                        </a-form-model-item>

                    </a-col>
                    <a-col span="12">
                        <a-button v-if="!disabledFB" type="primary" style="margin-top: 4px">添加新抽样单模板</a-button>
                    </a-col>
                </a-row>

                <a-row v-if="step===0||step===3">
                    <a-col span="24">
                        <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="附件" prop="planFile">
                            <a-ext-upload :disabled="true" v-model="formState.commonFile"></a-ext-upload>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row v-if="step===1||step===3">
                    <a-col span="24">
                        <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}"
                                           prop="monitTaskList">
                            <a-ext-check-target-picker-province  v-if="formState.plan.level==='省级'" :disabled="disabledFB"
                                    v-model="formState.monitTaskList"></a-ext-check-target-picker-province>
                            <a-ext-check-target-picker-city v-if="formState.plan.level==='市级'" :disabled="disabledFB"
                                                            v-model="formState.monitTaskList">
                            </a-ext-check-target-picker-city>
                            <a-ext-check-target-picker-county v-if="formState.plan.level==='区县级'&&!confirmLoading" :disabled="disabledFB"
                                                              v-model="formState.monitTaskList"></a-ext-check-target-picker-county>
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row v-if="step===2||step===3">
                    <a-col span="24">
                        <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}"
                                           prop="monitProduceList">
                            <a-ext-pin-zhong-and-bad-select v-if="formState.taskType==='抽样检测任务'" :disabled="disabledFB"
                                    v-model="formState.monitProduceList"></a-ext-pin-zhong-and-bad-select>
                            <a-ext-pin-zhong-select v-if="formState.taskType==='抽样任务'" :disabled="disabledFB"
                                                    v-model="formState.monitProduceList"></a-ext-pin-zhong-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>

            </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>

    import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
    import AExtDataPicker from '../../../components/AntDesignExt/All/AExtDataPicker'
    import AExtMonitLinkCheckBox from '../../../components/AntDesignExt/All/AExtMonitLinkCheckBox'
    import AExtPickSheetSelect from '../../../components/AntDesignExt/All/AExtPickSheetSelect'
    import AExtUpload from '../../../components/AntDesignExt/All/AExtUpload'
    import AExtCheckTargetPickerProvince from '../../../components/AntDesignExt/All/AExtCheckTargetPickerProvince'
    import AExtPinZhongAndBadSelect from '../../../components/AntDesignExt/All/AExtPinZhongAndBadSelect'
    import AExtPinZhongSelect from '../../../components/AntDesignExt/All/AExtPinZhongSelect'
    import AExtCheckTargetPickerCity from '../../../components/AntDesignExt/All/AExtCheckTargetPickerCity'
    import AExtCheckTargetPickerCounty from '../../../components/AntDesignExt/All/AExtCheckTargetPickerCounty'

    import {addorUpdateMonitProject as saveApi, getMonitProjectById as initApi} from '../../../api/api'
    import {FormRules} from 'antd-form-rules';

    export default {
        name: "FormModel",
        components: {
            AExtLocalDicSelect,
            AExtDataPicker,
            AExtMonitLinkCheckBox,
            AExtPickSheetSelect,
            AExtPinZhongSelect,
            AExtUpload,
            AExtCheckTargetPickerProvince,
            AExtPinZhongAndBadSelect,
            AExtCheckTargetPickerCity,
            AExtCheckTargetPickerCounty
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            param: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                confirmLoading: false,
                spinning: false,
                step:3,
                formState: {
                    name: '',
                    hangye: '',
                    plan: {name: ''},
                    taskType:
                        '',
                    startDate:
                        '',
                    endDate:
                        '',
                    monitLink:
                        '',
                    pickFormId:
                        '',
                    commonFile:
                        '',
                    monitTaskList:
                        [],
                    monitProduceList:
                        [],
                },
                rules: {
                    taskType: FormRules.withName('抽检任务类型').string(1, 50).isRequired().create(),
                    startDate:
                        FormRules.withName('监测项目实施时间').string(1, 50).isRequired().create(),
                    endDate:
                        FormRules.withName('至').string(1, 50).isRequired().create(),
                    monitLink:
                        FormRules.withName('监测环节').callback((value, field) => {
                            if (!value.length) {
                                return new Error('请选择');
                            }
                        }).create(),
                    pickFormId:
                        FormRules.withName('抽样单模板选择').isRequired().create(),
                    monitTaskRegionList:
                        FormRules.withName('地区及机构').isRequired().create(),
                    monitProduceList:
                        FormRules.withName('抽样品种及污染物选择').callback((value, field) => {
                            if (!value.length) {
                                return new Error('请选择');
                            }
                        }).create(),
                }
                ,

            }
                ;
        },
        computed:{
          disabledFB(){
              return this.step === 3;
          }
        },
        created() {
            this.initForm();
        },
        methods: {
            initForm() {
               this.getById()
            },
            handleOk(e) {
                this.save()
            },
            save(){
                this.$emit("update:visible", false)
            },
            getById(){
                if (this.param.id) {
                    this.spinning = true;
                    this.confirmLoading = true;
                    initApi(this.param).then((result => {
                        this.formState = result.data.data;
                        if(this.step===1)
                        {
                            if( this.formState.plan.level==='区县级') {
                                for (let i = 0; i < this.formState.monitTaskList.length; i++) {
                                    if(this.formState.monitTaskList[i].monitTaskRegionList.length===0) {
                                        this.formState.monitTaskList[i].monitTaskRegionList.push({
                                            regionCode:this.formState.monitTaskList[i].regionCode,
                                            regionName: this.formState.monitTaskList[i].regionName,
                                            pickCount: 1
                                        });
                                    }
                                }
                            }
                            else  if (this.formState.plan.level==='市级') {
                                this.formState.monitTaskList.forEach(item=>{
                                    if(item.monitTaskRegionList.length===0)
                                    {
                                        item.monitTaskRegionList.push({regionCode:item.regionCode,regionName:item.regionName,pickCount:0});
                                    }
                                });
                            }
                        }
                        this.confirmLoading = false;

                        this.spinning = false;
                    })).catch(() => {
                        this.confirmLoading = false;
                        this.spinning = false;
                    });
                }
            },
            handleCancel(e) {
                this.$emit("update:visible", false)
            },

        },
    }
</script>

<style scoped lang="scss">

    /deep/ .ant-modal-body {
        height: 60vh;
        overflow-y: scroll;
    }

</style>